module.exports = __webpack_public_path__ + "static/media/design-live.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/design-live.svg
// module id = 518
// module chunks = 0